import PageCommon from "./PageCommon.js";
import Pqp from "../3x1010/Pqp.js";
import Swipers from "../components/Swipers.js";
import { elapsedStart } from "../../inc/helpers.js";

export default class PageDefault extends PageCommon {
    constructor() {
        super();

        this._data = null;
        this._panelDebouncer = null;
        this._currentPayment = null;
    }

    init($data) {
        super.init($data);
        this._data = $data;

        this.showPreloader(false);
        Pqp.trace("PageDefault - Hello world");

        this.initBtnHp();
        this.initSwipers();

        // dispaccio un evento globale
        try {
            this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
        } catch (error) {
            console.log(error);
        }
    }

    initBtnHp() {
        const btn = document.querySelector(".js-toggle-donate-panel.js-show-after-hero");
        const hero = document.querySelector(".js-hero-section");

        if (!btn || !hero) return;

        const show = () => {
            btn.classList.remove("is-hidden");
            btn.removeAttribute("inert");
        }
        const hide = () => {
            if (!btn.classList.contains("is-hidden"))
                btn.classList.add("is-hidden");
            btn.setAttribute("inert", "");
        }

        let top = 0, y = window.scrollY;
        const onScroll = () => {
            y = window.scrollY;
            const toBottom = y > top;

            if (toBottom && top > hero.offsetHeight) {
                show();

            } else if (!toBottom && top <= hero.offsetHeight) {
                hide();
            }

            top = y;
        }
        window.addEventListener("scroll", onScroll);
        elapsedStart(() => {
            if (window.scrollY > hero?.offsetHeight)
                show();
        });
    }

    initSwipers() {
        const swipers = new Swipers();
        let instances = {
            projects: swipers.initSwiperProjects(),
            numbers: undefined
        };
        const breakpoint = 767;
        let resizing;

        if (window.matchMedia(`(max-width: ${breakpoint}px)`).matches)
            instances.numbers = swipers.initSwiperNumbers();

        window.addEventListener("resize", (e) => {
            clearTimeout(resizing);
            resizing = setTimeout(() => {
                if (window.matchMedia(`(max-width: ${breakpoint}px)`).matches) {
                    if (!instances.numbers)
                        instances.numbers = swipers.initSwiperNumbers();

                } else {
                    instances.numbers?.destroy(true, true);
                    instances.numbers = undefined;
                }
            }, 250);
        });
    }

    get isHomepage() {
        return true;
    }
}

